import React, { useState, useEffect } from "react";
import axios from 'axios';
import {
  Steps,
  Button,
  Form,
  Input,
  InputNumber,
  Select,
  Upload,
  Tag,
  Layout,
  Breadcrumb,
  Avatar,
  Checkbox,
  Modal,
  Row,
  Col,
  message,
  Tooltip,
  Alert,
} from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { EyeOutlined, HomeOutlined, UploadOutlined, DownloadOutlined } from "@ant-design/icons";
import thanks from "../../assets/images/thanks.png";
import AppHeaderHomePageTemplate from "./AppHeaderHomePageTemplate";
import useUserProfile from '../../useUserProfile';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';
import { ActionCardCatagories } from '../Atoms/ActionCardCatagories';
import { useTranslation } from 'react-i18next';
const { TextArea } = Input;
const { Content } = Layout;

const ApteanAwardsSection: React.FC = () => {
  
const isSubmittingRef = React.useRef(false);
  const location = useLocation();
  const rewardDetails = location.state?.rewardDetails;
  const preParentReward = location.state?.preParentReward;
  const parentReward = location.state?.parentReward;// Props for the eCards

  interface ECard {
    ecardId: string,
    eCardName: string,
    description: string,
    image: string,
    isActive: boolean,
    isDefault: boolean,
    valueId: string,
    title?: string,
    background?: string;
  }

  interface Reward {
    rewardTypeId: string;
    rewardName: string;
    type: string;
    requiresApproval: string;
    isActive: boolean;
    eligibleToNominate: string;
    budget: number | null;
    regionName: string[];
    rolesList: string[];
    approver1: string | null;
    approver2: string | null;
    approver3: string | null;
    approver4: string | null;
    approver5: string | null;
    createdAt: string;
    icon: string | null;
  }

  const hasMultipleRewards = Array.isArray(rewardDetails) && rewardDetails.length > 1;
  const hasMultipleCategories =
    rewardDetails?.[0]?.details && Object.keys(rewardDetails[0].details).length > 1;

  const [currentStep, setCurrentStep] = useState<number>(
    hasMultipleRewards || hasMultipleCategories ? 0 : 1
  );

  const [selectedValueTag, setSelectedValueTag] = useState<string>("");
  const [selectedValueName, setSelectedValueName] = useState<string>("");
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [ccChecked, setCcChecked] = useState<boolean>(false);
  const [addPeers, setAddPeers] = useState<boolean>(false);
  const [peersEmails, setPeersEmails] = useState<string[]>([]);

  const { requestProfileData } = useUserProfile();
  const [UserDetails, setUserDetails] = useState<{ id: string, displayName: string, email: string }[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [recipient, setRecipient] = useState<string | string[] | null>(null);
  const [recipientSearchResults, setRecipientSearchResults] = useState<{ id: string, displayName: string, email: string }[]>([]);
  const [recipientId, setRecipientId] = useState<string | null>(null);
  const [recipientEmail, setRecipientEmail] = useState<string | null>(null);
  const [values, setCoreValues] = useState<{ valueId: string; valueName: string }[]>([]);
  const [ccEmails, setCcEmails] = useState<string[]>([]);
  const { instance, accounts } = useMsal();
  const [fileList, setFileList] = useState<any[]>([]);
  const [nomineeSearchResults, setNomineeSearchResults] = useState<{ id: string, displayName: string, email: string }[]>([]);
  const [selectedReward, setSelectedReward] = useState<Reward | null>(null);
  const [selectedECard, setSelectedECard] = useState<string>("");
  const [isViewMoreModalVisible, setIsViewMoreModalVisible] = useState<boolean>(false);
  const [budgetData, setBudgetData] = useState<{ totalBudget: number; usedBudget: number; balance: number } | null>(null);
  const [duplicateWarning, setDuplicateWarning] = useState<string | null>(null);
  const [isTransferModalVisible, setIsTransferModalVisible] = useState<boolean>(false);
  const [sameDeptManagers, setSameDeptManagers] = useState<{ managerId: string; displayName: string; email: string; balance: number }[]>([]);
  const [transferToManagerId, setTransferToManagerId] = useState<string | null>(null);
  const [transferAmount, setTransferAmount] = useState<number | null>(null);
  const [isTransferring, setIsTransferring] = useState<boolean>(false);
  const [ecards, setEcards] = useState<ECard[]>([]);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [externalDocuments, setExternalDocuments] = useState<string | null>(null);
  const [isNextEnabled, setIsNextEnabled] = useState<boolean>(false);
  const [eligibleUsers, setEligibleUsers] = useState<{ id: string; displayName: string; email: string }[]>([]);
  const [loadingUsers, setLoadingUsers] = useState<boolean>(false);
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [adminBypass, setAdminBypass] = useState<boolean>(false);
  const [showInFeeds, setShowInFeeds] = useState<boolean>(false);
  const { t } = useTranslation();

  const [selectedContributions, setSelectedContributions] = useState<string[]>([]);

  // Update the fetchProfileData function to check if the user is an admin
  useEffect(() => {
    const userRole: string[] = location.state?.userRoles ?? [];
    setIsAdmin(userRole.includes('admin'));
  }, [location.state?.userRoles]);

  useEffect(() => {
    if (!hasMultipleRewards) {
      setSelectedReward(rewardDetails[0]);
    }
  }, [rewardDetails]);

  const fetchEligibleUsers = async (search: string) => {
    if (!search || search.length < 3) {
      setEligibleUsers([]);
      return;
    }

    setLoadingUsers(true);
    try {
      const token = await fetchToken();
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/Users/EligibleUsers`, {
        params: {
          search,
          rewardTypeId: selectedReward?.rewardTypeId,
          currentUserId: UserDetails[0]?.id,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setEligibleUsers(response.data);
    } catch (error) {
      console.error("Error fetching eligible users:", error);
    } finally {
      setLoadingUsers(false);
    }
  };

  const combinedResults = [...eligibleUsers];
  const uniqueResults = Array.from(new Set(combinedResults.map((item) => item.id))).map((id) =>
    combinedResults.find((item) => item.id === id)
  );

  const fetchToken = async () => {
    const res = await instance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0]
    });
    return res.idToken;
  };

  useEffect(() => {
    if (rewardDetails && rewardDetails.length > 0) {
      setSelectedReward(rewardDetails[0].rewardCategory);
    }
  }, [rewardDetails]);

  useEffect(() => {
    const fetchEcardsByCoreValue = async (coreValueId: string) => {
      try {
        const token = await fetchToken();
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/Ecards/ByCoreValue/${coreValueId}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        const ecardsWithBase64 = response.data.map((ecard: { description: string, ecardId: string, eCardName: string, image: string, isActive: boolean, isDefault: boolean, valueId: string }) => ({
          ecardId: ecard.ecardId,
          image: `data:image/jpeg;base64,${ecard.image}`,
          description: ecard.description,
          eCardName: ecard.eCardName,
          isActive: ecard.isActive,
          isDefault: ecard.isDefault,
          valueId: ecard.valueId,
        }));
        setEcards(ecardsWithBase64);

        // Automatically select the first eCard
        if (ecardsWithBase64.length > 0) {
          setSelectedECard(ecardsWithBase64[0].ecardId);
          form.setFieldsValue({ ecard: ecardsWithBase64[0].ecardId });
        }
      } catch (error) {
        console.error('Error fetching eCards:', error);
      }
    };

    if (selectedValueTag) {
      fetchEcardsByCoreValue(selectedValueTag);
    }
  }, [selectedValueTag]);

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        await requestProfileData();
        const userMail = localStorage.getItem("UserMail");
        const userName = localStorage.getItem("UserName");
        const userId = localStorage.getItem("UserId");
        setUserDetails([{ id: userId || '', displayName: userName || 'Default Nominator', email: userMail || '' }]);
      } catch (error) {
        console.error('Error fetching profile data:', error);
      }
    };

    fetchProfileData();

  }, [requestProfileData]);

  useEffect(() => {
    const fetchBudgetData = async () => {
      try {
        const token = await fetchToken();
        const managerId = localStorage.getItem("UserId");
        if (!managerId) {
          console.log('Manager ID not found in localStorage');
          return; // Exit if managerId is not available
        }
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/ManagerBudget/${managerId}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        if (response.data.length > 0) {
          const item = response.data[0];
          setBudgetData({
            totalBudget: item.totalBudget ?? item.TotalBudget ?? 0,
            usedBudget: item.usedBudget ?? item.UsedBudget ?? 0,
            balance: item.balance ?? item.Balance ?? 0,
          });
        }
      } catch (error) {
        console.error('Error fetching budget data:', error);
      }
    };

    fetchBudgetData();
  }, []);

  const fetchSameDeptManagers = async () => {
    try {
      const token = await fetchToken();
      const managerId = localStorage.getItem("UserId");
      if (!managerId) return;
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/ManagerBudget/same-department-managers/${managerId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSameDeptManagers(response.data);
    } catch (error) {
      console.error('Error fetching same department managers:', error);
    }
  };

  const handleTransferBudget = async () => {
    if (!transferToManagerId || !transferAmount || transferAmount <= 0) {
      message.error('Please select a manager and enter a valid amount.');
      return;
    }
    const fromManagerId = localStorage.getItem("UserId");
    if (!fromManagerId) return;
    if (budgetData && transferAmount > budgetData.balance) {
      message.error('Transfer amount exceeds your current balance.');
      return;
    }
    setIsTransferring(true);
    try {
      const token = await fetchToken();
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/ManagerBudget/transfer`,
        { fromManagerId, toManagerId: transferToManagerId, amount: transferAmount },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      message.success('Budget transferred successfully!');
      setIsTransferModalVisible(false);
      setTransferToManagerId(null);
      setTransferAmount(null);
      // Refresh budget data
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/ManagerBudget/${fromManagerId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.length > 0) {
        const item = response.data[0];
        setBudgetData({
          totalBudget: item.totalBudget ?? item.TotalBudget ?? 0,
          usedBudget: item.usedBudget ?? item.UsedBudget ?? 0,
          balance: item.balance ?? item.Balance ?? 0,
        });
      }
    } catch (error: any) {
      const errMsg = error?.response?.data || 'Failed to transfer budget.';
      message.error(typeof errMsg === 'string' ? errMsg : 'Failed to transfer budget.');
    } finally {
      setIsTransferring(false);
    }
  };

  useEffect(() => {
    const fetchNomineeData = async () => {
      try {
        const token = await fetchToken();

        const managerId = localStorage.getItem("UserId");
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/Users/ReportingToManager?managerId=${managerId}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }); setNomineeSearchResults(response.data);
      } catch (error) {
        console.error('Error fetching nominees:', error);
      }
    };

    fetchNomineeData();
  }, []);

  useEffect(() => {
    const getCcList = async () => {
      if (searchTerm.length < 3) {
        setRecipientSearchResults([]);
        return;
      }
      try {
        const token = await fetchToken();

        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/Users/SearchInCoe?search=${encodeURIComponent(searchTerm)}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        setRecipientSearchResults(response.data);
      } catch (error) {
        console.error('Error fetching recipients:', error);
      }
    };

    getCcList();
  }, [searchTerm]);

  useEffect(() => {
    const fetchCoreValues = async () => {
      try {
        const token = await fetchToken();
        const baseURL = process.env.REACT_APP_API_URL;
        const response = await axios.get(`${baseURL}/api/CoreValues/ActiveWithIds`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }); setCoreValues(response.data);
      } catch (error) {
        console.error('Error fetching values:', error);
      }
    };
    fetchCoreValues();
  }, []);

  const handleValueTagClick = (tagId: string, tagName: string) => {
    const newTagId = tagId === selectedValueTag ? "" : tagId;
    const newTagName = tagId === selectedValueTag ? "" : tagName;
    setEcards([]);
    setSelectedValueTag(newTagId);
    setSelectedValueName(newTagName);
    setSelectedECard("");
    form.setFieldsValue({ valueDemonstrated: newTagId });
  };

  const handleECardSelect = (cardId: string) => {
    setSelectedECard(cardId);
    form.setFieldsValue({ ecard: cardId });
  };

  const showViewMoreModal = () => {
    setIsViewMoreModalVisible(true);
  };

  const handleViewMoreCancel = () => {
    setIsViewMoreModalVisible(false);
  };

  const renderECardSelection = () => {
    const displayCards = ecards.slice(0, 3);
    const hasMoreCards = ecards.length > 3;

    return (
      <div>
        <Row gutter={16}>
          {displayCards.map((card, index) => (
            <Col span={8} key={card.ecardId}>
              <div
                style={{
                  width: '270px',
                  height: '140px',
                  cursor: 'pointer',
                  borderRadius: '8px',
                  border: selectedECard === card.ecardId ? '2px solid #8e24aa' : '1px solid #e0e0e0',
                  overflow: 'hidden',
                  position: 'relative',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                  transition: 'all 0.3s ease',
                  background: `url(${card.image}) no-repeat center center / cover`,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
                onClick={() => index !== 2 || !hasMoreCards ? handleECardSelect(card.ecardId) : showViewMoreModal()}
              >
                <div style={{
                  fontWeight: 'bold',
                  fontSize: '18px',
                  color: '#fff',
                  textAlign: 'center',
                  padding: '0 16px',
                  marginBottom: '10px',
                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                  borderRadius: '4px'
                }}>
                  {card.eCardName}
                </div>

                {index === 2 && hasMoreCards ? (
                  <Button
                    type="primary"
                    icon={<EyeOutlined />}
                    onClick={showViewMoreModal}
                    style={{
                      fontSize: '14px',
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      zIndex: 5,
                      background: '#8e24aa',
                      borderColor: '#8e24aa'
                    }}
                  >
                    View More
                  </Button>
                ) : null}

                {selectedECard === card.ecardId && (
                  <div style={{
                    position: 'absolute',
                    top: '8px',
                    right: '8px',
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    backgroundColor: '#8e24aa',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '14px',
                    fontWeight: 'bold'
                  }}>
                    ✓
                  </div>
                )}
              </div>
            </Col>
          ))}
        </Row>

        {hasMoreCards && (
          <div style={{ textAlign: 'center', marginTop: '15px' }}>
            <Button
              type="link"
              onClick={showViewMoreModal}
              style={{ color: '#8e24aa' }}
            >
              {t('view_more_ecards')}
            </Button>
          </div>
        )}

        <Modal
          title={t('select_ecard')}
          open={isViewMoreModalVisible}
          onCancel={handleViewMoreCancel}
          footer={null}
          width={800}
        >
          <Row gutter={[16, 16]}>
            {ecards.map(card => (
              <Col span={8} key={card.ecardId}>
                <div
                  style={{
                    width: '270px',
                    height: '140px',
                    cursor: 'pointer',
                    borderRadius: '8px',
                    border: selectedECard === card.ecardId ? '2px solid #8e24aa' : '1px solid #e0e0e0',
                    overflow: 'hidden',
                    position: 'relative',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    transition: 'all 0.3s ease',
                    background: `url(${card.image}) no-repeat center center / cover`,
                    backgroundSize: 'contain',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                  onClick={() => {
                    handleECardSelect(card.ecardId);
                    handleViewMoreCancel();
                  }}
                >
                  <div style={{
                    fontWeight: 'bold',
                    fontSize: '18px',
                    color: '#fff',
                    textAlign: 'center',
                    padding: '0 16px',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    borderRadius: '4px'
                  }}>
                    {card.eCardName}
                  </div>

                  {selectedECard === card.ecardId && (
                    <div style={{
                      position: 'absolute',
                      top: '8px',
                      right: '8px',
                      width: '24px',
                      height: '24px',
                      borderRadius: '50%',
                      backgroundColor: '#8e24aa',
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '14px',
                      fontWeight: 'bold'
                    }}>
                      ✓
                    </div>
                  )}
                </div>
              </Col>
            ))}
          </Row>
        </Modal>
      </div>
    );
  };

  const handleSubmitClick = async () => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setIsSubmitting(true);

    setIsSubmitting(true);
    const formData = form.getFieldsValue();
    const citation = form.getFieldValue('rewardTestimonial');
    const contributionTowards = selectedContributions;
    const businessOutcome = form.getFieldValue('businessOutcome');
    const teamName = form.getFieldValue('teamName'); // Get team name

    // Extract file type
    const fileType = fileList.length > 0 ? fileList[0].type : null;

    // Combine Contribution Towards and Business Outcome
    const contributionDetails =
      selectedReward?.requiresApproval === "global"
        ? {
          contributionTowards: Array.isArray(contributionTowards)
            ? contributionTowards.join(", ")
            : "", // Ensure it's an array before calling join
          businessOutcome: businessOutcome || "", // Provide a default value
        }
        : null;

    // Convert the file to base64
    interface ConvertToBase64 {
      (file: File): Promise<string>;
    }

    // Convert the file to base64
    interface ConvertToBase64 {
      (file: File): Promise<string>;
    }

    const convertToBase64: ConvertToBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve((reader.result as string).split(',')[1]); // Get the base64 part
        reader.onerror = (error) => reject(error);
      });
    };

    let externalDocuments = null;
    if (fileList.length > 0) {
      externalDocuments = await convertToBase64(fileList[0].originFileObj);
    }
    const externalDocumentsBase64 = externalDocuments ? await externalDocuments : null;
    setExternalDocuments(externalDocumentsBase64);

    // Prepare nominees based on recipientId
    let nominees: { userId: string | null }[] = [];
    if (selectedReward?.type.toLowerCase() == "team") {
      // For team awards, recipientId is a comma-separated string of IDs
      if (recipientId) {
        const ids = recipientId.split(','); // Split the IDs into an array
        nominees = ids.map((id) => ({
          userId: id || null,
        }));
      }
    } else {
      nominees = [
        {
          userId: recipientId || null,
        },
      ];
    }

    // Validate nominees unless admin bypass is enabled
    if (!adminBypass) {
      const invalidNominees = nominees.filter((nominee) => !nominee.userId);
      if (invalidNominees.length > 0) {
        message.error('One or more selected nominees are invalid. Please check your selection.');
        setIsSubmitting(false);
        return;
      }
    }

    const payload = {
      nomination: {
        rewardTypeId: selectedReward?.rewardTypeId,
        nominatorId: UserDetails[0]?.id,
        nominationDate: new Date().toISOString(),
        ccList: ccEmails.join(','),
        valueId: selectedValueTag,
        citation: '~citation~' + '\n' + citation + '\n' + (contributionDetails ? `~FormFields~  \n~contributionTowards~\n ${contributionDetails.contributionTowards}, ~businessOutcome~\n ${contributionDetails.businessOutcome}` : ""),
        externalDocuments: externalDocuments,
        eCardId: selectedECard,
        Filetype: fileType, // Add file type
        Team_name: teamName || null, // Add team name
        Visibility: adminBypass ? (showInFeeds == true ? "public" : "none") : "public",
      },
      nominees: nominees,
    };



    try {
      const token = await fetchToken();
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/RewardNomination/nominate`, payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      });

      if (response.status === 200) {
        if (selectedReward?.requiresApproval === "global") {
          var nominationId = response.data.nomination.nominationId;
          var approvalId = response.data.nomination.approvalID;

          const addPeerListDto = {
            addPeerCommentsDto: {
              nominationID: nominationId,
              approvalId: approvalId,
              assignedBy: UserDetails[0]?.id,
              createdBy: UserDetails[0]?.id,
            },
            assignedTo: peersEmails,
          };
          const responseStatus = await axios.post(`${process.env.REACT_APP_API_URL}/api/AddPeerComment/add-peer`, addPeerListDto, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`
            }
          });
        }
        setCurrentStep(currentStep + 1);
      }
    } catch (error: any) {
      const errMsg = error?.response?.data;
      if (typeof errMsg === 'string' && errMsg.length > 0) {
        message.error(errMsg);
      } else {
        message.error('Error submitting nomination');
      }
    } finally {
      setIsSubmitting(false);
      isSubmittingRef.current = false;
    }
  };

  // Function to decrypt base64 string
  const decryptBase64 = (base64String: string) => {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/octet-stream' });
    return URL.createObjectURL(blob);
  };

  // Function to handle download
  const handleDownload = async (fileName: string) => {
    // Convert the file to base64
    interface ConvertToBase64 {
      (file: File): Promise<string>;
    }

    const convertToBase64: ConvertToBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve((reader.result as string).split(',')[1]); // Get the base64 part
        reader.onerror = (error) => reject(error);
      });
    };

    let externalDocuments = null;
    if (fileList.length > 0) {
      externalDocuments = await convertToBase64(fileList[0].originFileObj);
    }

    if (externalDocuments) {
      const decryptedUrl = decryptBase64(externalDocuments);
      const link = document.createElement('a');
      link.href = decryptedUrl;
      link.download = fileName; // Use the actual file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const getColorFromName = (name: string) => {
    if (!name) return '#000000';
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xFF;
      color += ('00' + value.toString(16)).slice(-2);
    }
    return color;
  };

  const handleCcEmailChange = (value: string[]) => {
    setCcEmails(value);
  };
  const handlePeersEmailChange = (value: string[]) => {
    setPeersEmails(value);
  };

  const handleFileChange = ({ fileList }: any) => {
    setFileList(fileList.slice(-1)); // Allow only one file at a time
  };

  const renderValueDemonstrated = () => (
    <Form.Item
      label={t('value_demonstrated')}
      name="valueDemonstrated"
      required
      style={{ marginBottom: '24px' }}
    >
      <div className="contribution-tags" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '10px' }}>
        {values.length > 0 ? (
          values.map((value) => (
            <Tag
              key={value.valueId}
              className={`contribution-tag ${selectedValueTag === value.valueId ? "selected" : ""}`}
              onClick={() => handleValueTagClick(value.valueId, value.valueName)}
              style={{
                padding: '8px 16px',
                fontSize: '14px',
                cursor: 'pointer',
                borderRadius: '16px',
                backgroundColor: selectedValueTag === value.valueId ? '#8e24aa' : '#f0f0f0',
                color: selectedValueTag === value.valueId ? 'white' : 'black',
                border: 'none'
              }}
            >
              {value.valueName}
            </Tag>
          ))
        ) : (
          <div></div>
        )}
      </div>
    </Form.Item>
  );

  const renderNominationForm = () => {
    return (
      <>
        <h2 style={{ textAlign: 'center' }}>{selectedReward?.rewardName}</h2>
        {isAdmin && (
          <Form.Item style={{ marginBottom: '24px' }}>
            <Checkbox
              checked={adminBypass}
              onChange={(e) => setAdminBypass(e.target.checked)}
            >
              {t('admin_bypass')}
            </Checkbox>
          </Form.Item>
        )}
        {isAdmin && adminBypass && (
          <Form.Item style={{ marginBottom: '24px' }}>
            <Checkbox
              checked={showInFeeds}
              onChange={(e) => setShowInFeeds(e.target.checked)}
            >
              {t('show_in_feeds')}
            </Checkbox>
          </Form.Item>
        )}
        {(rewardDetails[0]?.eligibleToNominate === 'reportees') && (
          <Form.Item>
            <table className="budget-table" style={{ width: "100%", borderCollapse: "collapse", marginTop: "16px" }}>
              <thead>
                <tr>
                  <th style={{ border: "1px solid #ddd", padding: "8px", backgroundColor: "#f2f2f2", width: '33.3%' }}>Total Budget</th>
                  <th style={{ border: "1px solid #ddd", padding: "8px", backgroundColor: "#f2f2f2", width: '33.3%' }}>Budget Used</th>
                  <th style={{ border: "1px solid #ddd", padding: "8px", backgroundColor: "#f2f2f2", width: '33.3%' }}>Balance</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>{budgetData?.totalBudget ?? 0}</td>
                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>{budgetData?.usedBudget ?? 0}</td>
                  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>{budgetData?.balance ?? 0}</td>
                </tr>
              </tbody>
            </table>
          </Form.Item>
        )}
        <Form form={form} layout="vertical" className="nomination-form" style={{ marginTop: '30px' }}
          onValuesChange={handleFormValuesChange}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label={t('awarded_by')} name="nominatorName" style={{ marginBottom: '24px' }}>
                <Input
                  value={UserDetails[0]?.displayName || ' '}
                  disabled
                  prefix={
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Avatar
                        style={{
                          marginRight: '8px',
                          backgroundColor: getColorFromName(UserDetails[0]?.displayName || ''),
                        }}
                      >
                        {UserDetails[0]?.displayName?.charAt(0) || ''}
                      </Avatar>
                      <div style={{ lineHeight: '1.2', fontFamily: 'Roboto' }}>
                        <div style={{ fontSize: '14px', marginBottom: '4px' }}>
                          {UserDetails[0]?.displayName || ' '}
                        </div>
                        <div style={{ fontSize: '12px' }}>{UserDetails[0]?.email || ''}</div>
                      </div>
                      <span></span>
                    </div>
                  }
                  style={{ height: '50px' }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={t('select_nominee')}
                name="nominee"
                required
                style={{ marginBottom: '24px' }}
              >
                <div>
                  {/* Render selected nominees as tags outside the search box for "team" subcategory */}
                  {selectedReward?.type.toLowerCase() === 'team' && (
                    <div
                      style={{
                        marginBottom: '8px',
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '8px',
                      }}
                    >
                      {Array.isArray(recipient) &&
                        recipient.map((nominee) => (
                          <Tag
                            key={nominee}
                            closable
                            onClose={() => {
                              const updatedRecipients = recipient.filter(
                                (item) => item !== nominee
                              );
                              setRecipient(updatedRecipients);
                              form.setFieldsValue({ nominee: updatedRecipients });
                            }}
                            style={{
                              padding: '4px 12px',
                              fontSize: '14px',
                              borderRadius: '16px',
                              backgroundColor: '#f0f0f0',
                              color: '#333',
                            }}
                          >
                            {nominee}
                          </Tag>
                        ))}
                    </div>
                  )}

                  {/* Search box for selecting nominees */}
                  <Select
                    mode={
                      selectedReward?.type.toLowerCase() === 'team' ? 'multiple' : undefined
                    } // Enable multi-select for "team" subcategory
                    showSearch
                    placeholder={
                      selectedReward?.type.toLowerCase() === 'team'
                        ? 'Search nominees'
                        : 'Search nominee'
                    }
                    value={
                      recipient ||
                      (selectedReward?.type.toLowerCase() === 'team'
                        ? []
                        : 'Search nominee')
                    }
                    onSearch={fetchEligibleUsers}
                    onChange={(value, option) => {
                      handleRecipientSelect(value, option); // Use handleRecipientSelect here
                    }}
                    filterOption={false}
                    loading={loadingUsers}
                    style={{ width: '100%', height: '50px' }}
                    tagRender={
                      selectedReward?.type.toLowerCase() === 'individual'
                        ? undefined
                        : () => <span />
                    } // Disable tags inside the box for "team"
                  >
                    {uniqueResults.map(
                      (item) =>
                        item && (
                          <Select.Option
                            key={item.id}
                            value={item.email}
                            label={
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Avatar
                                  style={{
                                    marginRight: '8px',
                                    backgroundColor: getColorFromName(item.displayName),
                                  }}
                                >
                                  {item.displayName.charAt(0)}
                                </Avatar>
                                <div style={{ lineHeight: '1.2', fontFamily: 'Roboto' }}>
                                  <div style={{ fontSize: '14px', marginBottom: '4px' }}>
                                    {item.displayName}
                                  </div>
                                  <div style={{ fontSize: '12px', color: '#888' }}>
                                    {item.email}
                                  </div>
                                </div>
                              </div>
                            }
                          >
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <Avatar
                                style={{
                                  marginRight: '8px',
                                  backgroundColor: getColorFromName(item.displayName),
                                }}
                              >
                                {item.displayName.charAt(0)}
                              </Avatar>
                              <div style={{ lineHeight: '1.2', fontFamily: 'Roboto' }}>
                                <div style={{ fontSize: '14px', marginBottom: '4px' }}>
                                  {item.displayName}
                                </div>
                                <div style={{ fontSize: '12px', color: '#888' }}>
                                  {item.email}
                                </div>
                              </div>
                            </div>
                          </Select.Option>
                        )
                    )}
                  </Select>
                </div>
              </Form.Item>
              {duplicateWarning && (
                <Alert
                  type="warning"
                  showIcon
                  message={duplicateWarning}
                  style={{ marginTop: '-12px', marginBottom: '16px' }}
                />
              )}
            </Col>
          </Row>
          {selectedReward?.type.toLowerCase() === "team" && selectedReward?.requiresApproval === "global" && (
            <Form.Item
              label={t('team_name')}
              name="teamName"
              required={selectedReward?.type.toLowerCase() === "team"}
              style={{ marginBottom: "24px" }}
            >
              <Input
                placeholder="Enter team name"
                value={form.getFieldValue("teamName")}
                onChange={(e) => form.setFieldsValue({ teamName: e.target.value })}
                style={{ height: "50px" }}
              />
            </Form.Item>
          )}


          {!adminBypass && renderValueDemonstrated()}

          {!adminBypass && (
            <Form.Item label={t('select_ecard')} name="ecard" required style={{ marginBottom: '24px' }}>
              {renderECardSelection()}
            </Form.Item>
          )}
        </Form>
      </>
    );
  };

  const handleRewardSelect = (reward: any) => {
    setSelectedReward(reward);
    setCurrentStep(1);
  };

  useEffect(() => {
    if (!hasMultipleRewards) {
      setSelectedReward(rewardDetails[0]);
    }
  }, [rewardDetails]);

  useEffect(() => {
  }, [selectedReward]);

  const renderRewardSelection = () => {
    if (hasMultipleRewards) {
      return (
        <div>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "20px", position: "relative" }}>
            <h2 style={{ margin: 0 }}>{parentReward.title}</h2>
            {(rewardDetails[0]?.eligibleToNominate === 'reportees') && (
              <Button
                type="default"
                style={{ borderColor: '#1677ff', color: '#1677ff', position: "absolute", right: 0 }}
                onClick={() => {
                  fetchSameDeptManagers();
                  setIsTransferModalVisible(true);
                }}
                disabled={!budgetData || budgetData.balance <= 0}
              >
                Transfer Budget
              </Button>
            )}
          </div>
          {(rewardDetails[0]?.eligibleToNominate === 'reportees') && (
            <Form.Item>
              <table className="budget-table" style={{ width: "100%", borderCollapse: "collapse", marginTop: "16px" }}>
                <thead>
                  <tr>
                    <th style={{ border: "1px solid #ddd", padding: "8px", backgroundColor: "#f2f2f2", width: '33.3%' }}>Total Budget</th>
                    <th style={{ border: "1px solid #ddd", padding: "8px", backgroundColor: "#f2f2f2", width: '33.3%' }}>Budget Used</th>
                    <th style={{ border: "1px solid #ddd", padding: "8px", backgroundColor: "#f2f2f2", width: '33.3%' }}>Balance</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>{budgetData?.totalBudget ?? 0}</td>
                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>{budgetData?.usedBudget ?? 0}</td>
                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>{budgetData?.balance ?? 0}</td>
                  </tr>
                </tbody>
              </table>
            </Form.Item>
          )}

          <Modal
            title="Transfer Budget"
            open={isTransferModalVisible}
            onCancel={() => {
              setIsTransferModalVisible(false);
              setTransferToManagerId(null);
              setTransferAmount(null);
            }}
            onOk={handleTransferBudget}
            okText="Transfer"
            confirmLoading={isTransferring}
            okButtonProps={{ disabled: !transferToManagerId || !transferAmount || transferAmount <= 0 }}
          >
            <p style={{ marginBottom: '8px', color: '#555' }}>
              Available Balance: <strong>{budgetData?.balance ?? 0}</strong>
            </p>
            <Form layout="vertical">
              <Form.Item label="Transfer To (Same Department Manager)" required>
                <Select
                  placeholder="Select a manager"
                  value={transferToManagerId}
                  onChange={(val) => setTransferToManagerId(val)}
                  style={{ width: '100%' }}
                  notFoundContent="No managers found in your department"
                >
                  {sameDeptManagers.map((mgr) => (
                    <Select.Option key={mgr.managerId} value={mgr.managerId}>
                      {mgr.displayName} ({mgr.email}) — Balance: {mgr.balance}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item label="Amount" required>
                <InputNumber
                  min={1}
                  max={budgetData?.balance ?? 0}
                  value={transferAmount}
                  onChange={(val) => setTransferAmount(val)}
                  style={{ width: '100%' }}
                  placeholder="Enter amount to transfer"
                />
              </Form.Item>
            </Form>
          </Modal>

          <Row gutter={[14, 14]}
            justify="center"
            align="middle"
          >
            {rewardDetails
              .sort((a: any, b: any) => (a.budget || 0) - (b.budget || 0)) // Sort rewards by budget (ascending)
              .map((reward: any, index: number) => {
                const isDisabled =
                  rewardDetails[0]?.eligibleToNominate === 'reportees' &&
                  (budgetData?.balance || 0) < (reward.budget || 0); // Apply budget condition only for 'reportees'

                return (
                  <Col
                    xs={14.5} // Full width on extra small screens
                    sm={14.5} // Half width on small screens
                    md={14.5} // One-third width on medium screens
                    lg={14.5} // One-third width on large screens
                    xl={14.5} // One-third width on extra-large screens  
                    key={index}>
                    <Tooltip
                      title={
                        isDisabled
                          ? `Insufficient balance. Requires ${reward.budget} points.`
                          : reward.budget
                            ? ``
                            : ""
                      }
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          opacity: isDisabled ? 0.5 : 1, // Grayed-out style for disabled cards
                          pointerEvents: isDisabled ? "none" : "auto", // Disable click for grayed-out cards
                        }}
                        onClick={() => !isDisabled && handleRewardSelect(reward)} // Prevent click if disabled
                      >
                        <ActionCardCatagories
                          icon={
                            reward.icon ? (
                              <img
                                src={`data:image/svg+xml;base64,${reward.icon}`} // Use the base64 string as the image source
                                alt={reward.rewardName || "Reward Icon"}
                                className="w-12 h-12 object-contain"
                              />
                            ) : (
                              <div className="w-12 h-12 flex items-center justify-center">Unknown</div>
                            )
                          }
                          title={(reward.rewardName) || "Unknown Title"} // Ensure title is a string
                          message={""}
                          background={"#68C4D8"}
                          border={"1px solid #68C4D8"}
                          variant="default"
                        />
                      </div>
                      <div style={{ textAlign: "center", fontSize: "14px", color: "#555" }}>
                      </div>
                    </Tooltip>
                  </Col>
                );
              })}
          </Row>
        </div>
      );
    } else {
      return renderNominationForm();
    }
  };
  const renderStepContent = () => {
    if (currentStep === 0) {
      if (hasMultipleRewards) {
        return renderRewardSelection();
      } else if (hasMultipleCategories) {
        return renderRewardSelection();
      } else {
        return renderNominationForm();
      }
    }
    if (currentStep === 1) {
      return renderNominationForm();
    }
    if (currentStep === 2) {
      if (selectedReward?.requiresApproval === "global") {
        return renderContributionTowardsForm(); // Contribution Towards step for global approval
      } else {
        return renderCitationsForm(); // Skip Contribution Towards and go to Citation
      }
    }
    if (currentStep === 3) {
      if (selectedReward?.requiresApproval === "global") {
        return renderCitationsForm(); // Citation step after Contribution Towards
      } else {
        return renderPreview(); // Skip Citation and go to Preview
      }
    }
    if (currentStep === 4) {
      if (selectedReward?.requiresApproval === "global") {
        return renderPreview(); // Preview step after Citation
      } else {
        return renderThankYou(); // Skip Preview and go to Thank You
      }
    }
    if (currentStep === 5 && selectedReward?.requiresApproval === "global") {
      return renderThankYou(); // Thank You step for global approval
    }
    return null;
  };

  const renderContributionTowardsForm = () => (
    <Form
      form={form}
      layout="vertical"
      className="contribution-form"
      style={{ marginTop: "30px" }}
      onValuesChange={handleFormValuesChange}
      initialValues={{
        contributionTowards: [], // Initialize as an empty array
        businessOutcome: "", // Initialize as an empty string
      }}
    >
      <Form.Item
        label={t('contribution_Towards')}
        name="contributionTowards"
        rules={[
          { required: true, message: "Please select at least one contribution" },
        ]}
        style={{ marginBottom: "24px" }}
      >
        <div
          className="contribution-tags"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            marginTop: "10px",
          }}
        >
          {[
            { label: "Cloud Adoption", value: "Cloud Adoption" },
            { label: "Customer Focus & Organic Growth", value: "Customer Focus & Organic Growth" },
            { label: "Acquisition Excellence", value: "Acquisition Excellence" },
            { label: "High Performing Team", value: "High Performing Team" },
            { label: "Product Focus", value: "Product Focus" },
            { label: "Technology Excellence", value: "Technology Excellence" },
            { label: "Success Enabler", value: "Success Enabler" },

          ].map((contribution) => (
            <Tag
              key={contribution.value}
              className={`contribution-tag ${selectedContributions.includes(contribution.value) ? "selected" : ""
                }`}
              onClick={() => {
                const currentValues = [...selectedContributions];
                const newValues = currentValues.includes(contribution.value)
                  ? currentValues.filter((val) => val !== contribution.value)
                  : [...currentValues, contribution.value];
                setSelectedContributions(newValues); // Update state
                form.setFieldsValue({ contributionTowards: newValues }); // Sync with form
              }}
              style={{
                padding: "8px 16px",
                fontSize: "14px",
                cursor: "pointer",
                borderRadius: "16px",
                backgroundColor: selectedContributions.includes(contribution.value)
                  ? "#8e24aa"
                  : "#f0f0f0",
                color: selectedContributions.includes(contribution.value)
                  ? "white"
                  : "black",
                border: "none",
              }}
            >
              {contribution.label}
            </Tag>
          ))}
        </div>
      </Form.Item>

      <Form.Item
        label={t('values_demonstrated_outcome')}
        name="businessOutcome"
        rules={[
          { required: true, message: "Please provide a business outcome" },
          { min: 300, message: "Citation must be at least 300 characters" },
        ]}
        style={{ marginBottom: "24px" }}
      >
        <TextArea
          rows={4}
          placeholder="Describe the business outcome..."
          maxLength={1000}
          showCount
        />
      </Form.Item>
    </Form>
  );

  useEffect(() => {
    form.setFieldsValue({
      contributionTowards: form.getFieldValue("contributionTowards") || [],
    });
  }, [currentStep]);

  const isAceOrAviaAward = () => {
    const name = (selectedReward?.rewardName || '').toLowerCase();
    const parentName = (parentReward?.title || '').toLowerCase();
    return name.includes('ace') || name.includes('avia') || parentName.includes('ace') || parentName.includes('avia');
  };

  const checkHalfYearDuplicate = async (nomineeIds: string[]) => {
    if (!isAceOrAviaAward()) { setDuplicateWarning(null); return; }
    try {
      const token = await fetchToken();
      const nominatorId = localStorage.getItem("UserId");
      const now = new Date();
      const period = now.getMonth() < 6 ? 'H1' : 'H2';
      const periodLabel = period === 'H1' ? 'H1 (January – June)' : 'H2 (July – December)';

      const checks = nomineeIds.map(nomineeId =>
        axios.get(`${process.env.REACT_APP_API_URL}/api/RewardNomination/check-half-year-duplicate`, {
          params: { nominatorId, nomineeId, rewardTypeId: selectedReward?.rewardTypeId },
          headers: { Authorization: `Bearer ${token}` }
        })
      );
      const results = await Promise.all(checks);
      const anyDuplicate = results.some(r => r.data?.isDuplicate === true);
      if (anyDuplicate) {
        setDuplicateWarning(`This nominee has already been nominated for this award in ${periodLabel} ${now.getFullYear()}. You cannot nominate the same person more than once per half-year.`);
      } else {
        setDuplicateWarning(null);
      }
    } catch {
      setDuplicateWarning(null);
    }
  };

  const handleRecipientSelect = (value: string | string[], option: any) => {
    const managerId = localStorage.getItem("UserId"); // Get the manager's ID from localStorage
    setDuplicateWarning(null);

    if (Array.isArray(value)) {
      // For team awards (multi-select)
      const selectedIds = option.map((opt: any) => opt.key); // Extract IDs from options

      // Check if the manager's ID is in the selected IDs
      if (selectedIds.includes(managerId)) {
        message.error("You cannot select yourself as a nominee.");
        return; // Prevent selection
      }

      const selectedNames = option.map((opt: any) => opt.value); // Extract names from options
      const selectedEmails = selectedIds.map((id: string) =>
        nomineeSearchResults.find((item) => item.id === id)?.email || null
      );

      setRecipientId(selectedIds.join(',')); // Set IDs as a comma-separated string
      setRecipientEmail(selectedEmails.join(',')); // Set emails as a comma-separated string
      setRecipient(selectedNames); // Set names as an array
      checkHalfYearDuplicate(selectedIds);
    } else {
      // For individual awards (single-select)
      if (option.key === managerId) {
        message.error("You cannot select yourself as a nominee.");
        return; // Prevent selection
      }

      setRecipientId(option.key); // Set the ID
      setRecipientEmail(
        nomineeSearchResults.find((item) => item.id === option.key)?.email || null
      ); // Find and set the email
      setRecipient(value); // Set the name
      checkHalfYearDuplicate([option.key]);
    }
  };

  useEffect(() => {
    handleFormValuesChange(); // Trigger validation whenever the step changes
  }, [currentStep]);

  const handleFormValuesChange = () => {
    const contributionTowards = form.getFieldValue("contributionTowards");
    const businessOutcome = form.getFieldValue("businessOutcome");
    const rewardTestimonial = form.getFieldValue("rewardTestimonial");

    if (selectedReward?.requiresApproval === "global") {
      if (currentStep === 2) {
        // Step 2: Contribution Towards and Business Outcome
        setIsNextEnabled(
          Array.isArray(contributionTowards) &&
          contributionTowards.length > 0 && // At least one contribution selected
          businessOutcome &&
          businessOutcome.length >= 30 // Business Outcome has at least 30 characters
        );
      } else if (currentStep === 3) {
        // Step 3: Reward Testimonial
        setIsNextEnabled(
          rewardTestimonial &&
          rewardTestimonial.length >= 30 // Reward Testimonial has at least 30 characters
        );
      }
    } else {
      if (currentStep === 2) {
        // Step 2: Reward Testimonial (when approval is not global)
        setIsNextEnabled(
          rewardTestimonial &&
          rewardTestimonial.length >= 30 // Reward Testimonial has at least 30 characters
        );
      }
    }
  };

  const renderCitationsForm = () => (
    <Form form={form} layout="vertical" className="nomination-form" style={{ marginTop: '30px' }}
      onValuesChange={handleFormValuesChange} // Add this line
    >
      <Form.Item
        label={t('citation')}
        name="rewardTestimonial"
        rules={[
          { required: true, message: "Please provide a citation" },
          { min: 300, message: "Citation must be at least 300 characters" },
        ]}
        style={{ marginBottom: '0px' }}
      >
        <TextArea
          rows={4}
          placeholder={t('write_message_here')}
          maxLength={1000}
          showCount
        />
      </Form.Item>
      <p style={{ margin: '0px 0px 24px 0px ', padding: '0px', fontSize: '12px', color: '#888' }}>
        <strong>{t('write_up')}</strong>
      </p>
      <Form.Item
        label={t('upload_documents')}
        name="documents"
        rules={[{ required: false, message: "Please upload documents" }]}

        style={{ marginBottom: '24px' }}
      >
        <div>
          <Upload.Dragger
            name="files"
            action="/upload.do"
            fileList={fileList}
            onChange={handleFileChange}
            beforeUpload={(file) => {
              const isValidType = [
                "image/jpeg",
                "image/png",
                "application/pdf",
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "application/vnd.ms-excel",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "text/plain",
                "application/vnd.ms-powerpoint",
                "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                "application/zip",
                "application/x-gzip",
                "application/x-7z-compressed",
                "application/x-rar-compressed",
                "text/csv",
              ].includes(file.type);
              const isValidSize = file.size / 1024 / 1024 < 5;

              if (!isValidType) {
                Modal.error({
                  title: "Invalid file type",
                  content:
                    "Please upload a valid file format. (Use jpg/jpeg/png for images, pdf for pdf files, dot/doc/docx for doc files, xls/xlsx for excel files, txt for text files, ppt/pptx for ppt files, zip/gz/7z/rar for compressed files)",
                });
                return Upload.LIST_IGNORE;
              }

              if (!isValidSize) {
                Modal.error({
                  title: "File too large",
                  content: "Upload file less than 5 MB.",
                });
                return Upload.LIST_IGNORE;
              }

              return true;
            }}
            style={{ padding: "14px 0" }}
          >
            <p className="ant-upload-drag-icon">
              <UploadOutlined />
            </p>
            <p className="ant-upload-text">Click or drag file to this area to upload</p>
          </Upload.Dragger>

          <div style={{ fontSize: '12px', color: '#888', marginTop: '5px' }}>
            <Tooltip
              title={
                <>
                  <p style={{ margin: '0px' }}>Please provide document in valid format.</p>
                  <p style={{ margin: '0px' }}>
                    (Use jpg/jpeg/png for images, pdf for pdf files, dot/doc/docx for doc files,
                    xls/xlsx for excel files, txt for text files, ppt/pptx for ppt files,
                    zip/gz/7z/rar for compressed files)
                  </p>
                  <p style={{ margin: '0px' }}>Upload file less than 5 MB.</p>
                </>
              }
            >
              <strong
                style={{
                  margin: '0px',
                  padding: '0px',
                  cursor: 'pointer',
                  textDecoration: 'none', // No underline by default
                }}
                onMouseEnter={(e) => (e.currentTarget.style.textDecoration = 'underline')} // Add underline on hover
                onMouseLeave={(e) => (e.currentTarget.style.textDecoration = 'none')} // Remove underline when not hovered
              >
                {t('supportable_formats')}
              </strong>
            </Tooltip>
          </div>

          {fileList.length > 0 && (
            <div style={{ marginTop: "20px" }}>
              <h3>{t('uploaded_documents')}:</h3>
              {fileList.map((file) => (
                <div key={file.uid} style={{ marginBottom: "10px" }}>
                  {file.type.startsWith("image/") ? (
                    <img src={URL.createObjectURL(file.originFileObj)} alt={file.name} style={{ maxWidth: "100%" }} />
                  ) : (
                    <a href={URL.createObjectURL(file.originFileObj)} target="_blank" rel="noopener noreferrer">
                      {file.name}
                    </a>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

      </Form.Item>

      <Row gutter={14}>
        <Col span={12}>
          <Form.Item style={{ marginBottom: '24px' }}>
            <Checkbox checked={ccChecked} onChange={(e) => setCcChecked(e.target.checked)}>
              CC
            </Checkbox>
            {ccChecked && (
              <Select
                mode="tags"
                style={{ width: (selectedReward?.requiresApproval === "global") ? '100%' : '200%', marginTop: '10px' }}
                placeholder="Enter email addresses"
                onSearch={setSearchTerm}
                onChange={handleCcEmailChange}
                value={ccEmails}
              >
                {recipientSearchResults.map(email => (
                  <Select.Option key={email.id} value={email.email}>
                    {email.email}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        {selectedReward?.requiresApproval === "global" && (
          <Col span={12}>
            <Form.Item style={{ marginBottom: '24px' }}>
              <Checkbox checked={addPeers} onChange={(e) => setAddPeers(e.target.checked)}>
                {t('add_additional_reviewers')}
              </Checkbox>
              {addPeers && (
                <>
                  <Select
                    mode="tags"
                    style={{ width: '100%', marginTop: '10px' }}
                    placeholder="Enter email addresses"
                    onSearch={setSearchTerm}
                    onChange={handlePeersEmailChange}
                    value={peersEmails}
                    maxLength={2}
                  >
                    {peersEmails.length < 2 && recipientSearchResults.length > 0 && recipientSearchResults.map(email => (
                      <Select.Option key={email.id} value={email.email}>
                        {email.email}
                      </Select.Option>
                    ))}
                  </Select>
                  <p style={{ margin: '0px 0px 24px', padding: '0px', fontSize: '12px', color: 'rgb(136, 136, 136)' }}>Requesting feedback from additional reviewers (2 Max) </p>
                </>
              )}
            </Form.Item>
          </Col>
        )}
      </Row>

    </Form>
  );
  // Move the useEffect to the main component
  useEffect(() => {
    if ((currentStep === 5 && selectedReward?.requiresApproval === "global") || (currentStep === 4 && selectedReward?.requiresApproval !== "global")) { // Check if the current step is the "Thank You" step
      // Remove vertical scroll
      document.body.style.overflow = 'hidden';
      
      const timer = setTimeout(() => {
        navigate("/"); // Redirect to the home page after 10 seconds
      }, 10000); // 10 seconds

      return () => {
        clearTimeout(timer); // Clear the timer if the component unmounts
        document.body.style.overflow = 'auto'; // Restore scroll
      };
    } else {
      // Restore scroll for other steps
      document.body.style.overflow = 'auto';
    }
  }, [currentStep]); // Add currentStep as a dependency

  const renderThankYou = () => {
    return (
      <div
        className="thanks-image"
        style={{
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "20px 50px",
          backgroundColor: "#f9f9f9",
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <img src={thanks} alt="Thanks" style={{ width: "120px", marginBottom: "10px" }} />
        <div style={{ textAlign: "center" }}>
          <h1 style={{ color: "#8e24aa", fontSize: "28px", marginBottom: "8px" }}>Thank You</h1>
          <h3 style={{ color: "#333", fontSize: "18px", marginBottom: "15px" }}>
            {selectedReward?.requiresApproval !== "global" ? (
              <span>Your Nomination is submitted successfully!</span>
            ) : (
              <span style={{ fontSize: '16px' }}>Your nomination is submitted and will be sent to your manager followed by ELT review.</span>
            )}
          </h3>
          <Button
            size="large"
            style={{
              background: "#8e24aa",
              color: "white",
              padding: "8px 20px",
              fontSize: "15px",
              height: "auto",
              borderRadius: "4px",
            }}
            onClick={() => navigate("/")}
          >
            {t('go_to_home_page')}
          </Button>
        </div>
      </div>
    );
  };

  // Find the selected eCard details
  const selectedECardDetails = ecards.find(card => card.ecardId === selectedECard);

  const renderPreview = () => {
    const selectedECardDetails = ecards.find((card) => card.ecardId === selectedECard);

    return (
      <div
        className="preview-content"
        style={{
          padding: "20px",
          backgroundColor: "#f9f9f9",
          borderRadius: "10px",
          marginTop: "30px",
        }}
      >
        <h2 style={{ color: "#8e24aa", fontSize: "28px", marginBottom: "20px" }}>
          {t('preview_nomination')}
        </h2>
        <Form layout="vertical">
          {/* Nominator */}
          <Form.Item label={t('nominator')}>
            <Input
              disabled
              value={UserDetails[0]?.displayName || "Nominator Name"}
              style={{ marginBottom: "24px" }}
            />
          </Form.Item>

          {/* Nominee */}
          <Form.Item label={t('nominee')}>
            <Input
              disabled
              value={recipient || "Nominee Name"}
              style={{ marginBottom: "24px" }}
            />
          </Form.Item>

          {/* Values */}
          <Form.Item label={t('values')}>
            {selectedValueTag && (
              <Tag
                style={{
                  padding: "8px 16px",
                  fontSize: "14px",
                  borderRadius: "16px",
                  backgroundColor: "#8e24aa",
                  color: "white",
                  border: "none",
                  marginBottom: "24px",
                }}
              >
                {selectedValueName ||
                  values.find((value) => value.valueId === selectedValueTag)?.valueName ||
                  "No Value Selected"}
              </Tag>
            )}
          </Form.Item>

          {/* Selected eCard */}
          <Form.Item label={t('selected_ecard')}>
            {selectedECard && (
              <div
                style={{
                  width: "200px",
                  height: "100px",
                  borderRadius: "8px",
                  border: "1px solid #e0e0e0",
                  overflow: "hidden",
                  marginBottom: "24px",
                  background: selectedECardDetails
                    ? `url(${selectedECardDetails.image}) no-repeat center center / cover`
                    : "linear-gradient(135deg, #f5d0ff 0%, #d691f9 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    color: "#fff",
                    textAlign: "center",
                    padding: "0 16px",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    borderRadius: "4px",
                  }}
                >
                  {selectedECardDetails
                    ? selectedECardDetails.eCardName
                    : "No eCard Selected"}
                </div>
              </div>
            )}
          </Form.Item>

          {/* Reward Testimonial */}
          <Form.Item label={t('reward_testimonial')}>
            <TextArea
              rows={4}
              value={form.getFieldValue("rewardTestimonial") || "No Testimonial Provided"}
              disabled
              style={{ marginBottom: "24px", resize: "none" }}
            />
          </Form.Item>

          {/* Uploaded Documents */}
          <Form.Item label={t('uploaded_documents')}>
            {fileList.length > 0 ? (
              fileList.map((file) => (
                <Button
                  key={file.uid}
                  type="primary"
                  icon={<DownloadOutlined />}
                  onClick={() => handleDownload(file.name)}
                  style={{
                    marginTop: "20px",
                    backgroundColor: "#8e24aa",
                    borderColor: "#8e24aa",
                  }}
                >
                  {file.name}
                </Button>
              ))
            ) : (
              <span>{t('no_documents_uploaded')}</span>
            )}
          </Form.Item>

          {/* CC */}
          <Form.Item label="CC">
            <Input value={ccChecked ? "Yes" : "No"} disabled />
            {ccChecked && (
              <div style={{ marginTop: "10px" }}>
                {ccEmails.map((email) => (
                  <Tag
                    key={email}
                    color="blue"
                    style={{
                      fontSize: "14px",
                      marginBottom: "5px",
                      backgroundColor: "#8e24aa",
                      border: "none",
                      color: "white",
                    }}
                  >
                    {email}
                  </Tag>
                ))}
              </div>
            )}
          </Form.Item>

          {/* Peers */}
          <Form.Item label={t('additional_reviewers')}>
            <Input value={addPeers ? "Yes" : "No"} disabled />
            {addPeers && (
              <div style={{ marginTop: "10px" }}>
                {peersEmails.map((email) => (
                  <Tag
                    key={email}
                    color="blue"
                    style={{
                      fontSize: "14px",
                      marginBottom: "5px",
                      backgroundColor: "#8e24aa",
                      border: "none",
                      color: "white",
                    }}
                  >
                    {email}
                  </Tag>
                ))}
              </div>
            )}
          </Form.Item>
        </Form>
      </div>
    );
  };

  return (
    <Layout style={{ height: "100%" }}>
      <AppHeaderHomePageTemplate />
      <Content style={{ padding: "1px 0" }}>
        <Breadcrumb
          style={{
            marginTop: "5px",
            marginBottom: "10px",
            padding: "1px 30px",
          }}
        >
          <Breadcrumb.Item>
            <a onClick={() => navigate("/home")}>
              <HomeOutlined />
              <span style={{ marginLeft: "8px" }}>{t('home')}</span>
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a onClick={() => navigate(-1)}>
              {preParentReward.title}
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{parentReward.title}</Breadcrumb.Item>
        </Breadcrumb>

        <div
          className="awards-section"
          style={{
            maxWidth: "880px",
            margin: "0 auto",
            padding: "30px",
            backgroundColor: "#fff",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        >
          <Steps
            current={currentStep}
            items={[
              { title: t('select_reward') },
              { title: t('nomination') },
              ...(selectedReward?.requiresApproval === "global"
                ? [{ title: "Contribution Towards" }]
                : []),
              { title: t('citation') },
              { title: t('preview') },
              { title: t('thank_you') },
            ]}
            progressDot
            style={{ marginBottom: "40px" }}
          />

          <div className="step-content">{renderStepContent()}</div>
          {/* Hide buttons on Thank You step */}
          {!((currentStep === 5 && selectedReward?.requiresApproval === "global") || (currentStep === 4 && selectedReward?.requiresApproval !== "global")) && (
            <div className="step-actions" style={{ marginTop: "40px", display: "flex", justifyContent: "space-between", padding: "0 10px" }}>
              {currentStep > 0 && (hasMultipleRewards || currentStep >= 1) && (
                <Button
                  size="large"
                  onClick={() => setCurrentStep((prev) => prev - 1)}
                  style={{
                    padding: "0 32px",
                    height: "48px",
                    borderRadius: "4px",
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "160px",
                  }}
                  disabled={(currentStep === 1 && !hasMultipleRewards) || (currentStep == 4 && selectedReward?.requiresApproval != "global") || currentStep == 5}

                >
                  {t('back')}
                </Button>
              )}

              {currentStep < 5 && currentStep >= 1 && (
                <Button
                  size="large"
                  type="primary"
                  onClick={() => {
                    if (currentStep === 4 || (currentStep === 3 && selectedReward?.requiresApproval !== "global")) {
                      handleSubmitClick(); 
                    } else {
                      setCurrentStep((prev) => prev + 1); 
                    }
                  }}
                  loading={isSubmitting}
                  style={{
                    padding: "0 32px",
                    height: "48px",
                    backgroundColor: "#8e24aa",
                    borderColor: "#8e24aa",
                    borderRadius: "4px",
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "160px",
                  }}
                  disabled={
                    (currentStep === 1 && !form.getFieldValue("nominee")) ||
                    (currentStep === 1 &&
                      !adminBypass &&
                      (!form.getFieldValue("valueDemonstrated") || !form.getFieldValue("ecard"))) ||
                    (currentStep === 1 && !!duplicateWarning) ||
                    (currentStep > 1 && !isNextEnabled) ||
                    isSubmitting
                  }
                >
                  {currentStep === 4 || (currentStep === 3 && selectedReward?.requiresApproval !== "global")
                    ? t('submit')
                    : (currentStep === 3 && selectedReward?.requiresApproval === "global") || (currentStep === 2 && selectedReward?.requiresApproval !== "global")
                      ? t('preview')
                      : t('next')}
                </Button>
              )}
            </div>
          )}
        </div>
      </Content>
    </Layout>
  );
};

export default ApteanAwardsSection;